"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Swisstopo = exports.SpainIdee = exports.Google = exports.OpenStreetMap = exports.Geoportal = void 0;
const Geoportal_1 = __importDefault(require("./Geoportal"));
exports.Geoportal = Geoportal_1.default;
const OpenStreetMap_1 = __importDefault(require("./OpenStreetMap"));
exports.OpenStreetMap = OpenStreetMap_1.default;
const Google_1 = __importDefault(require("./Google"));
exports.Google = Google_1.default;
const SpainIdee_1 = __importDefault(require("./SpainIdee"));
exports.SpainIdee = SpainIdee_1.default;
const Swisstopo_1 = __importDefault(require("./Swisstopo"));
exports.Swisstopo = Swisstopo_1.default;
const all = [
    Geoportal_1.default,
    OpenStreetMap_1.default,
    Google_1.default,
    SpainIdee_1.default,
    Swisstopo_1.default,
];
exports.default = all;
